(function () {
  var IMAGES = {
    'Image #1': {
      src: 'https://cdn.shopify.com/s/files/1/0568/3301/6007/files/Product_Page-03.png',
      alt: 'Acapulco 76 — playa dorada de los años 70'
    },
    'Image #2': {
      src: 'https://cdn.shopify.com/s/files/1/0568/3301/6007/files/Product_Page-04.png',
      alt: 'Acapulco 76 — auto vintage al atardecer'
    }
  };

  // Genera srcset responsive aprovechando el CDN de Shopify
  function srcset(url) {
    if (url.indexOf('cdn.shopify.com') === -1) return null;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return [400, 600, 800, 1200, 1600].map(function (w) {
      return url + sep + 'width=' + w + ' ' + w + 'w';
    }).join(', ');
  }

  function buildFigure(cfg) {
    var fig = document.createElement('figure');
    fig.className = 'metafield-inline-image';

    var img = document.createElement('img');
    img.src = cfg.src;
    img.alt = cfg.alt || '';
    img.loading = 'lazy';
    img.decoding = 'async';

    var ss = srcset(cfg.src);
    if (ss) {
      img.srcset = ss;
      img.sizes = '(min-width: 990px) 50vw, 100vw';
    }

    fig.appendChild(img);

    if (cfg.caption) {
      var cap = document.createElement('figcaption');
      cap.textContent = cfg.caption;
      fig.appendChild(cap);
    }
    return fig;
  }

  function render(scope) {
    var container = (scope || document).querySelector('#description-global-section');
    if (!container || container.dataset.imagesRendered === 'true') return;

    container.querySelectorAll('h6').forEach(function (h6) {
      // "[Image #1]" -> "Image #1" (tolera espacios y &nbsp;)
      var key = h6.textContent
        .replace(/\u00a0/g, ' ')
        .replace(/[\[\]]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      var cfg = IMAGES[key];
      if (!cfg) return;

      h6.replaceWith(buildFigure(cfg));
    });

    container.dataset.imagesRendered = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { render(); });
  } else {
    render();
  }

  document.addEventListener('shopify:section:load', function (e) { render(e.target); });
})();